/**
 * Validator utils.
 * Custom message (không phụ thuộc tên biến lỗi):
 * - validateFields: mỗi field thêm { message: 'Câu thông báo' } (optional).
 * - handlerError: thêm tham số thứ 5 messageMap = { [source]: 'Câu thông báo' } (optional).
 */
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
const isValidPhone = (phone) => /^\d{10}$/.test(phone)

const getRequiredMessage = (errorField) => {
    const defaultMessage = 'Vui lòng nhập thông tin bắt buộc'

    if (typeof errorField === 'string' && (errorField.toLowerCase().includes('err_start_date') || errorField.toLowerCase().includes('err_end_date'))) {
        return 'Vui lòng nhập thời gian'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_partner')) {
        return 'Vui lòng nhập đối tác'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_password')) {
        return 'Vui lòng nhập mật khẩu'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_grade_level')) {
        return 'Vui lòng nhập cấp học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_detailed_report')) {
        return 'Vui lòng nhập báo cáo'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_circulars')) {
        return 'Vui lòng nhập thông tư'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_data_type')) {
        return 'Vui lòng nhập loại dữ liệu'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_user_name')) {
        return 'Vui lòng nhập tên đăng nhập'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_unit_type')) {
        return 'Vui lòng nhập loại đơn vị'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_template')) {
        return 'Vui lòng nhập tên mẫu'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_report')) {
        return 'Vui lòng nhập tên báo cáo'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_type_report')) {
        return 'Vui lòng nhập loại báo cáo'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_submitting_authority')) {
        return 'Vui lòng nhập đơn vị yêu cầu nộp'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_pw_new')) {
        return 'Vui lòng nhập mật khẩu mới'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_retype_pw')) {
        return 'Vui lòng nhập lại mật khẩu mới'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_account_name')) {
        return 'Vui lòng nhập tên tài khoản'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_user_name')) {
        return 'Vui lòng nhập tên đăng nhập'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_email')) {
        return 'Vui lòng nhập email'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_phone')) {
        return 'Vui lòng nhập số điện thoại'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_role')) {
        return 'Vui lòng nhập vai trò'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_ward')) {
        return 'Vui lòng nhập tên phường/xã'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_code_ward')) {
        return 'Vui lòng nhập mã phường/xã'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_education_department')) {
        return 'Vui lòng nhập phường/xã'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_village')) {
        return 'Vui lòng nhập tên tổ thôn'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_code_village')) {
        return 'Vui lòng nhập mã tổ thôn'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_role')) {
        return 'Vui lòng nhập tên vai trò'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_desc')) {
        return 'Vui lòng nhập mô tả'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_school_code')) {
        return 'Vui lòng nhập mã trường học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_school_name')) {
        return 'Vui lòng nhập tên trường học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_school_type')) {
        return 'Vui lòng nhập loại hình trường'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_grade_group')) {
        return 'Vui lòng nhập nhóm cấp học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_type_of_education')) {
        return 'Vui lòng nhập loại hình đào tạo'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_teacher')) {
        return 'Vui lòng nhập họ tên'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_birthday')) {
        return 'Vui lòng nhập ngày sinh'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_status')) {
        return 'Vui lòng nhập trạng thái'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_job_position')) {
        return 'Vui lòng nhập vị trí việc làm'
    }
    
    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_name_class')) {
        return 'Vui lòng nhập tên lớp'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_snake_case')) {
        return 'Vui lòng nhập số buổi học trên tuần'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_school_block')) {
        return 'Vui lòng nhập khối học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_class_name')) {
        return 'Vui lòng nhập lớp học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_full_name')) {
        return 'Vui lòng nhập họ tên'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_date_of_birth')) {
        return 'Vui lòng nhập ngày sinh'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_gender')) {
        return 'Vui lòng nhập giới tính'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_student_status')) {
        return 'Vui lòng nhập trạng thái học sinh'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_date_status')) {
        return 'Vui lòng nhập ngày trạng thái'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_nation')) {
        return 'Vui lòng nhập dân tộc'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_school_label')) {
        return 'Vui lòng nhập trường học'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_cccd')) {
        return 'Vui lòng nhập CCCD/CMND'
    }

    if (typeof errorField === 'string' && errorField.toLowerCase().includes('err_unit_education')) {
        return 'Vui lòng nhập đơn vị quản lý'
    }

    return defaultMessage
}
/**
 * Validate danh sách field. Mỗi field: { value, errorField, type?, message? }
 * - message (optional): câu thông báo khi trống, không phụ thuộc tên errorField → tránh trùng giữa các màn.
 */
export const validateFields = (component, fields) => {
    let isValid = true

    fields.forEach(({ value, errorField, type, message }) => {
        // Date object hoặc array 2 phần tử (daterange) đều coi là đã nhập
        const isEmpty =
            value == null ||
            value === '' ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && !(value instanceof Date) && value.length === 0)
        if (isEmpty) {
            component[errorField] = message != null ? message : getRequiredMessage(errorField)
            isValid = false
        } else {
            component[errorField] = ''

            if (type === 'email' && !isValidEmail(value)) {
                component[errorField] = 'Email không hợp lệ'
                isValid = false
            }

            if (type === 'phone' && !isValidPhone(value)) {
                component[errorField] = 'Số điện thoại không hợp lệ'
                isValid = false
            }
        }
    })

    return isValid
}

/**
 * Xử lý lỗi khi input thay đổi.
 * - errorFieldMap: { [source]: errorField } (vd: { name: 'err_name', code: 'err_code' })
 * - messageMap (optional): { [source]: 'Câu thông báo khi trống' } → custom theo từng màn, không cần đổi tên biến lỗi.
 */
export const handlerError = (component, source, newValue, errorFieldMap, messageMap) => {
    const errorField = errorFieldMap[source]
    const requiredMessage =
        messageMap && source in messageMap
            ? messageMap[source]
            : getRequiredMessage(errorField)
    component[errorField] = newValue ? '' : requiredMessage

    if (source === 'email' && newValue && !isValidEmail(newValue)) {
        component[errorField] = 'Email không hợp lệ'
    }

    if (source === 'phone' && newValue && !isValidPhone(newValue)) {
        component[errorField] = 'Số điện thoại không hợp lệ'
    }
}

export const updateChangedTitles = (
    objectTitle,
    changedTitles,
    source,
    newValue
) => {
    const title = objectTitle?.[source]
    const isValidNewValue =
        (newValue || newValue === false) && newValue !== 'Invalid date'
    const updatedTitles =
        title && isValidNewValue
            ? changedTitles.includes(title)
                ? changedTitles
                : [...changedTitles, title]
            : changedTitles.filter((t) => t !== title)

    return Array.isArray(updatedTitles) ? updatedTitles : []
}
